import { useState } from 'react';
import { Box, Button, Grid, Typography, useMediaQuery } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { styles } from '../../styles';
import { QuestionnaireRow } from './QuestionnaireRow';
import { useQuestionnaireQuery } from '~/queries/useQuestionnaireQuery';
import { useSelector } from 'react-redux';
import TitlePencilField from '~/components/TitlePencilField/TitlePencilFIeld';
import { TableHeader } from '~/components/ListCardTable/TableHeader';
import { theme } from '~/theme';
import { additionalInfoColumns } from '../../constants';
import { getTypeMessages } from '~/modules/identification/forms/GeneralInfo/utils.ts';
import { commonStyles } from '~/theme/styles/commonStyles';
import { BaseModal } from '~/components/modals/BaseModal/BaseModal.tsx';
import { selectClientType } from '~/store/identification-form/selectors';
import { isBoolean } from 'lodash';

export const AdditionQuestionnaire = () => {
  const {
    control,
    trigger,
    getValues,
    formState: { errors },
  } = useFormContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const clientType = useSelector(selectClientType);
  const questionnaire = useWatch({ control, name: 'questionnaire' });
  const { questions } = useQuestionnaireQuery(clientType);
  const [isOpened, setIsOpened] = useState(false);
  const { headerMessage, infoMessage } = getTypeMessages(clientType as string);

  const handleClose = () => {
    setIsOpened(false);
    trigger('questionnaire');
  };

  const handleOpen = () => {
    setIsOpened(true);
  };

  return (
    <Grid size={12}>
      <TitlePencilField
        onClick={handleOpen}
        dataName="questionnaire"
        title="Додаток до Анкети-опитувальника"
        errorMessage={(errors?.questionnaire?.message as string) || ''}
      />
      <BaseModal
        open={isOpened}
        onClose={handleClose}
        containerProps={{ sx: styles.additinalInfoContainer }}
      >
        <Typography variant="h6">{headerMessage}</Typography>
        <Typography variant="body2" align="center">
          {infoMessage}
        </Typography>
        <Box sx={styles.table}>
          {!isMobile && <TableHeader columns={additionalInfoColumns} position="static" />}
          <Box sx={{ ...commonStyles.columnFlexContainer, gap: { sm: 2, md: 0, xs: 2 } }}>
            {Object.keys(questionnaire).map((_, index) => (
              <QuestionnaireRow
                key={questions[index]?.id || index}
                index={index}
                question={questions[index]?.question as string}
                showDefaultError={
                  !isBoolean(getValues(`questionnaire.question${index + 1}`)) &&
                  !!errors.questionnaire
                }
              />
            ))}
          </Box>
        </Box>
        <Button variant="contained" onClick={handleClose}>
          Продовжити
        </Button>
      </BaseModal>
    </Grid>
  );
};
